var _excluded = ["attribution", "attributionDisclosure", "attributionHref", "attributionSubtitle", "children", "classes", "variant"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
require("./quote.css");
var styles = {
  "text": "text-1dLXH",
  "text__stylized": "text__stylized-15fDK",
  "attributions": "attributions-5O4iv",
  "attributionSubtitle": "attributionSubtitle-27xzH",
  "attributionDisclosure": "attributionDisclosure-3ZziY"
};
import LinkGenerator from '../link-generator';
var Quote = _ref => {
  var {
      attribution,
      attributionDisclosure,
      attributionHref,
      attributionSubtitle,
      children,
      classes,
      variant
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  var isSimple = variant === 'simple';
  var isStylized = variant === 'stylized';
  var AttributionTag = attributionHref ? LinkGenerator : 'span';
  return /*#__PURE__*/React.createElement("blockquote", _extends({
    className: cs(classes.container)
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: cs(styles.text, {
      [styles.text__stylized]: isStylized,
      ['lll-text-medium']: isSimple,
      ['lll-text-small']: isStylized
    }, classes.text)
  }, children), /*#__PURE__*/React.createElement("div", {
    className: cs(styles.attributions, classes.attributions)
  }, attribution && /*#__PURE__*/React.createElement(AttributionTag, {
    className: cs('lll-text-body-2', 'lll-font-weight-medium', {
      ['lll-link-primary']: !!attributionHref
    }, classes.attribution),
    href: attributionHref || undefined
  }, attribution), attributionSubtitle && /*#__PURE__*/React.createElement("span", {
    className: cs('lll-text-body-2', styles.attributionSubtitle, classes.attributionSubtitle)
  }, attributionSubtitle), attributionDisclosure && /*#__PURE__*/React.createElement("span", {
    className: cs('lll-text-body-3', styles.attributionDisclosure, classes.attributionDisclosure)
  }, attributionDisclosure)));
};
Quote.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.shape({
    container: PropTypes.string,
    text: PropTypes.string,
    attributions: PropTypes.string,
    attribution: PropTypes.string,
    attributionDisclosure: PropTypes.string,
    attributionSubtitle: PropTypes.string
  }),
  /** Attribute the quote to its source/author */
  attribution: PropTypes.string,
  /** Disclose whether the quote is part of a paid partnership */
  attributionDisclosure: PropTypes.string,
  /** Used if Attribution is authored as a link */
  attributionHref: PropTypes.string,
  attributionSubtitle: PropTypes.string,
  /** Changes the visual style (default is 'stylized') */
  variant: PropTypes.oneOf(['simple', 'stylized'])
};
Quote.defaultProps = {
  attribution: null,
  attributionDisclosure: null,
  attributionHref: null,
  attributionSubtitle: null,
  classes: {},
  variant: 'stylized'
};
export default Quote;